define(function(require) {
   'use strict';

   var AppStarter = require('AppStarter');

   AppStarter.start();
});